// extracted by mini-css-extract-plugin
export default {"container":"Recommneted_container__unp2t","recomends":"Recommneted_recomends__TQSmd","recomend":"Recommneted_recomend__zmntj"};